<script>
export default {
    data() {
        return {
            showScheduleTypeModal: false,
            isLoading: false,
            selectedMaster: {},
            CourseDialog: false,
            checkMobile: false,
            isUser: false,
            showCodeBox: false,
            mobile: null,
            code: null,
            password: null,
            msg: null,
            disabledButton:false,
            terms: false,
            masterReservForm: this.$inertia.form({
                category: null,
                time: null,
                time_zone: null,
                master_profile_id: null,
                type: null,
            }, {
                resetOnSuccess: false,
                bag: 'masterReservForm'
            })
        }
    },
    methods: {
        setSelectedDate(e, _timezone) {
            if (e && typeof e.format === "function") {
                this.masterReservForm.time = e.format("YYYY-MM-DD HH:mm");
                this.masterReservForm.time_zone = _timezone;
            }
        },
        showSchedule() {
            return this.selectedMaster.schedule &&
                this.selectedMaster.start_time &&
                this.selectedMaster.end_time &&
                this.selectedMaster.course_time
        },
        booking() {
            if (this.masterReservForm.time && !this.$page.props.user && !this.isUser) {
                this.CourseDialog = false
                this.checkMobile = true
                // window.location.href='/login'
            } else {
                this.masterReservForm.post('/get-course', {
                    onSuccess: () => this.CourseDialog = true
                })
            }
        },
        closeCheckMobil() {
            this.checkMobile = false;
            this.code = null;
            this.mobile = null;
            this.password = null;
            this.isUser = false;
            this.showCodeBox = false;
            this.msg = null;
            this.masterReservForm.reset();
            this.selectedMaster = {};
            this.$page.props.error = null;
        },
        getCourse(_master) {
            this.selectedMaster = _master;
            this.CourseDialog = true;
            this.masterReservForm.master_profile_id = _master.id;
            this.masterReservForm.category = window.location.pathname;
            this.masterReservForm.type = _master.type;
        },
        login() {
            if ( this.mobile && this.password) {
                this.msg = null;
                this.$inertia.post('/userLogin', {email: this.mobile, password: this.password}, {
                    onSuccess: () => {
                        this.$page.props.user ? this.checkMobile = false : ''
                        this.booking()
                    }
                })
            } else if ( this.mobile && !this.password ) {
                this.msg = 'Please enter your password!';
            } else {
                this.msg = 'Please enter your information carefully.';
            }
        },
        checkCode() {
            this.msg = null;
            if ( this.mobile && this.password && this.terms ) {
                let data = {active_code: this.code, email: this.mobile, ajax: true, password: this.password};
                this.$inertia.post('/user-activate-master', data , {
                    onSuccess: () => {
                        this.$page.props.user ? this.checkMobile = false : ''
                        this.booking()
                    }
                })
            } else if( this.mobile && !this.password && this.terms ) { 
                this.msg = 'Please enter your password!';
            } else if( this.mobile && this.password && !this.terms) {
                this.msg = 'Please check the Terms of Service and Privacy Policy!';
            } else {
                this.msg = 'Please enter your password and check the Terms of Service and Privacy Policy!';
            }
        },
        checkUser() {
            if (this.mobile) {
                this.disabledButton = true;
                this.server_response = false
                this.isUser = false
                this.showCodeBox = false
                this.msg = null;
                this.isLoading = true;
                axios.get(`/get-user?email=${this.mobile}`)
                    .then(response => {
                        if (response.data.email) {
                            this.isUser = true
                            this.msg = `Please log in to your panel!`;
                            this.isLoading = false;
                        } else {
                            this.verificationMobile();
                        }
                    }).catch((error) => {
                        //
                    })
                    .finally( () => {
                        this.disabledButton = false;
                    });
            } else {
                this.msg = 'Please enter your email address!';
            }
        },
        verificationMobile() {
            if (!this.server_response) {
                this.isLoading = true;
                axios.post('/validation-email', {email: this.mobile}).then(response => {
                    this.showCodeBox = true
                    // this.msg = `Confirmation code sent to mail ${this.mobile} `
                }).catch((error) => {
                    let errors = error.response.data.errors;
                    // this.msg = errors['mobile'];
                })
                .finally( () => {
                    this.isLoading = false;
                })
                this.server_response = true
            }
        },
        openScheduleTypeModal(_master){
            this.selectedMaster = _master;
            this.showScheduleTypeModal = true;
        },
        closeScheduleTypeModal(){
            this.showScheduleTypeModal = false;
        },
        selectScheduleType(_data){
            this.showScheduleTypeModal = false;
            this.selectedMaster.type = _data;
            this.getCourse(this.selectedMaster);
        },
    }
}
</script>